<template>
  <footer class="pc-footer">
    <div class="footer-inner">
      <!-- 1. Partner 品牌 Logo 跑马灯（压缩高度） -->
      <div class="footer-partner" v-if="swiperList.length">
        <h4>{{ $t('bottom_contact_page.bootom_partner', 'Partner') }}</h4>
        <div class="swiper-container" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
          <vue-seamless-scroll ref="firstScroll" :data="firstRowList" :class-option="scrollOption" class="seamless-warp">
            <div class="swiper-wrapper">
              <div class="swiper-item" v-for="(item, index) in firstRowList" :key="`first-${index}`" @click="handleSwiperItemClick(item)">
                <img :src="item.image" :alt="item.name" />
              </div>
            </div>
          </vue-seamless-scroll>
          <vue-seamless-scroll ref="secondScroll" :data="secondRowList" :class-option="scrollOption" class="seamless-warp">
            <div class="swiper-wrapper">
              <div class="swiper-item" v-for="(item, index) in secondRowList" :key="`second-${index}`" @click="handleSwiperItemClick(item)">
                <img :src="item.image" :alt="item.name" />
              </div>
            </div>
          </vue-seamless-scroll>
        </div>
      </div>

      <!-- 2. 三列主区：门店地址 / 快速导航 / 联系我们 -->
      <div class="footer-columns">
        <!-- 列1：门店地址（SEO 友好，地址纯文本 + tel 链接） -->
        <div class="footer-col col-stores" v-if="storeList.length">
          <div class="col-title">{{ $t('bottom_contact_page.store_title', 'Our Showrooms') }}</div>
          <div class="store-list">
            <div class="store-card" v-for="store in storeList" :key="store.id || store.country_code">
              <div class="store-head">
                <span class="store-flag" aria-hidden="true">{{ store.flag || '🏢' }}</span>
                <span class="store-name">{{ store.name || store.country }}</span>
              </div>
              <div class="store-info">
                <a class="store-address" :href="getMapUrl(store)" target="_blank" rel="noopener noreferrer" :title="$t('bottom_contact_page.view_map', 'View on Google Maps')">
                  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
                  <span class="address-text">
                    {{ store.address }}
                    <span v-if="store.address_local" class="address-local">{{ store.address_local }}</span>
                    <span class="address-map-link">{{ $t('bottom_contact_page.view_map', 'View on Google Maps') }} ›</span>
                  </span>
                </a>
                <div class="store-contacts-row">
                  <a v-if="store.phone" class="store-tel" :href="`tel:${store.phone.replace(/\s+/g, '')}`">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
                    {{ store.phone }}
                  </a>
                  <a v-if="store.phone2 && store.phone2 !== store.phone" class="store-tel" :href="`tel:${store.phone2.replace(/\s+/g, '')}`">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
                    {{ store.phone2 }}
                  </a>
                  <a v-if="store.telegram" class="store-link-icon" :href="store.telegram" target="_blank" rel="noopener noreferrer" :title="$t('bottom_contact_page.telegram', 'Telegram')">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>
                  </a>
                  <a v-if="store.whatsapp" class="store-link-icon" :href="store.whatsapp" target="_blank" rel="noopener noreferrer" :title="'WhatsApp'">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/></svg>
                  </a>
                  <a v-if="store.email" class="store-link-icon" :href="`mailto:${store.email}`" :title="$t('bottom_contact_page.email_label', 'Email')">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 12.713l-11.985-9.713h23.97l-11.985 9.713zm0 2.574l-12-9.725v15.438h24v-15.438l-12 9.725z"/></svg>
                  </a>
                </div>
              </div>
              <div class="store-actions">
                <button class="store-inquiry-btn" @click="openInquiry(store)">
                  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>
                  {{ $t('bottom_contact_page.inquiry_btn', 'Inquiry') }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- 列2：快速导航 -->
        <div class="footer-col col-nav">
          <div class="col-title">{{ $t('bottom_contact_page.bootom_navigation', 'Navigation') }}</div>
          <div class="nav-list">
            <router-link v-for="item in navList" :key="item.name" :to="item.path" class="nav-link">
              {{ item.name }}
            </router-link>
          </div>
          <div class="legal-links">
            <router-link to="/user-agreement" class="legal-link">{{ $t('bottom_contact_page.privacy_policy', 'Privacy Policy') }}</router-link>
            <router-link to="/page/Service" class="legal-link">{{ $t('bottom_contact_page.terms_service', 'Terms of Service') }}</router-link>
          </div>
        </div>

        <!-- 列3：联系我们 -->
        <div class="footer-col col-contact">
          <div class="col-title">{{ $t('bottom_contact_page.contact_title', 'Contact Us') }}</div>
          <div class="contact-list" v-if="contactInfo.contact_phone || contactInfo.contact_email || contactInfo.contact_whatsapp">
            <a v-if="contactInfo.contact_phone" class="contact-item" :href="`tel:${contactInfo.contact_phone.replace(/\s+/g, '')}`">
              <span class="ci-icon">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
              </span>
              <span>
                <span class="ci-label">{{ $t('bottom_contact_page.phone_label', 'Phone') }}</span>
                {{ contactInfo.contact_phone }}
              </span>
            </a>
            <a v-if="contactInfo.contact_email" class="contact-item" :href="`mailto:${contactInfo.contact_email}`">
              <span class="ci-icon">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 12.713l-11.985-9.713h23.97l-11.985 9.713zm0 2.574l-12-9.725v15.438h24v-15.438l-12 9.725z"/></svg>
              </span>
              <span>
                <span class="ci-label">{{ $t('bottom_contact_page.email_label', 'Email') }}</span>
                {{ contactInfo.contact_email }}
              </span>
            </a>
            <a v-if="contactInfo.contact_whatsapp" class="contact-item" :href="`https://api.whatsapp.com/send?l=en&phone=${contactInfo.contact_whatsapp}`" target="_blank" rel="noopener noreferrer">
              <span class="ci-icon">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/></svg>
              </span>
              <span>
                <span class="ci-label">WhatsApp</span>
                {{ contactInfo.contact_whatsapp }}
              </span>
            </a>
          </div>
          <button class="contact-inquiry-btn" v-if="contactInfo.contact_email || contactInfo.contact_phone" @click="openInquiry(null)">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>
            {{ $t('bottom_contact_page.contact_btn', 'Send Inquiry') }}
          </button>
          <div class="qr-row" v-if="contactInfo.contact_wechat_url || contactInfo.contact_whatsapp_url">
            <div class="qr-item" v-if="contactInfo.contact_wechat_url">
              <img :src="contactInfo.contact_wechat_url" :alt="$t('bottom_contact_page.wechat_qr', 'WeChat QR')" class="qr-thumb" @click="openQrPreview(contactInfo.contact_wechat_url, $t('bottom_contact_page.wechat_scan', 'Scan to add on WeChat'))" />
              <p>{{ $t('bottom_contact_page.wechat_scan', 'Scan to add on WeChat') }}</p>
            </div>
            <div class="qr-item" v-if="contactInfo.contact_whatsapp_url">
              <img :src="contactInfo.contact_whatsapp_url" :alt="$t('bottom_contact_page.whatsapp_qr', 'WhatsApp QR')" class="qr-thumb" @click="openQrPreview(contactInfo.contact_whatsapp_url, $t('bottom_contact_page.whatsapp_scan', 'Scan to chat on WhatsApp'))" />
              <p>{{ $t('bottom_contact_page.whatsapp_scan', 'Scan to chat on WhatsApp') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 3. 底部版权条 -->
    <div class="footer-bottom">
      <div class="footer-bottom-inner">
        <p class="copyright">
          © {{ currentYear }} Jingsun Car Co., Ltd. All Rights Reserved.
          <span v-if="icpNumber" class="icp">{{ icpNumber }}</span>
          <!-- 关联站点外链：同一主体的另一站点，帮助搜索引擎/AI 识别实体关系 -->
          <span class="outlink">
            <a href="https://www.jingsuncar.com/" target="_blank" rel="noopener">Jingsun Car – SUV, Sedan &amp; Pickup Truck Supply</a>
          </span>
        </p>
        <div class="footer-icon-list">
          <div class="footer-icon" :class="`footer-icon-list-${icon.type_code}`" v-for="icon in iconList" :key="icon.id" :data-icon-id="icon.id" :data-icon-type="icon.type_code" :data-contact-value="icon.contact_value" @click="handleIconClick(icon)" @mouseenter="handleIconMouseEnter" @mouseleave="handleIconMouseLeave">
            <img :src="icon.icon" :alt="icon.type_name" />
            <div class="footer-tooltip" v-show="showTooltip === icon.id" :class="`footer-icon-list-${icon.type_code}`">
              <img v-if="icon.type_code === 'wechat' || icon.type_code === 'whatsapp'" :src="icon.qrcode" alt="QR Code" class="tooltip-image" />
              <span v-else>{{ icon.contact_value }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 4. 咨询弹窗（van-popup 居中） -->
    <van-popup v-model="showInquiry" round class="inquiry-popup" :close-on-click-overlay="true">
      <div class="inquiry-box">
        <div class="inquiry-header">
          <h4>{{ $t('bottom_contact_page.email_form_name', 'Contact Us') }}</h4>
          <p v-if="inquiryStore">{{ inquiryStore.name }}</p>
          <p v-else>{{ $t('bottom_contact_page.inquiry_sub', 'We will reply within 24 hours.') }}</p>
          <button class="inquiry-close" @click="showInquiry = false" aria-label="Close">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
          </button>
        </div>
        <textarea class="form-textarea" :placeholder="$t('bottom_contact_page.email_form_content_son', 'Input content here...')" v-model="formData.message"></textarea>
        <input class="form-input" :placeholder="$t('bottom_contact_page.email_form_whatsapp', 'Your WhatsApp')" v-model="formData.whatsapp" />
        <input type="email" class="form-input" :placeholder="$t('bottom_contact_page.email_form_send_son', 'Your Email')" v-model="formData.email" />
        <button class="form-submit" @click="handleSubmit" :disabled="contactLoading">
          {{ contactLoading ? '...' : $t('bottom_contact_page.email_form_button_name', 'Send') }}
        </button>
      </div>
    </van-popup>

    <!-- 5. 二维码放大预览弹窗 -->
    <van-popup v-model="showQrPreview" round class="qr-preview-popup" :close-on-click-overlay="true">
      <div class="qr-preview-box">
        <button class="inquiry-close qr-preview-close" @click="showQrPreview = false" aria-label="Close">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
        </button>
        <img :src="previewQrUrl" :alt="previewQrTitle" />
        <p>{{ previewQrTitle }}</p>
      </div>
    </van-popup>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      iconList: [],
      navList: [],
      swiperList: [],
      contactInfo: {},
      storeList: [],
      icpNumber: '',
      currentYear: new Date().getFullYear(),
      showInquiry: false,
      showQrPreview: false,
      previewQrUrl: '',
      previewQrTitle: '',
      inquiryStore: null,
      formData: {
        message: '',
        whatsapp: '',
        email: ''
      },
      contactLoading: false,
      isHovering: false,
      showTooltip: null
    }
  },
  computed: {
    // 将数据分成两行
    firstRowList() {
      if (!this.swiperList.length) return []
      const mid = Math.ceil(this.swiperList.length / 2)
      return [...this.swiperList.slice(0, mid), ...this.swiperList.slice(0, mid)]
    },
    secondRowList() {
      if (!this.swiperList.length) return []
      const mid = Math.ceil(this.swiperList.length / 2)
      return [...this.swiperList.slice(mid), ...this.swiperList.slice(mid)]
    },
    scrollOption() {
      return {
        step: this.isHovering ? 0 : 0.5,
        limitMoveNum: 0,
        hoverStop: true,
        direction: 2, // 向左滚动
        openWatch: true,
        singleWidth: 0,
        waitTime: 0
      }
    }
  },
  created() {
    this.loadData()
  },
  watch: {
    // 切换国家（URL ?country=N）时实时刷新联系方式与门店，无需手动刷新页面
    '$route.query.country'(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.loadContactInfo()
      }
    }
  },
  methods: {
    loadData() {
      this.$http.get('/contact/chat_list').then(res => {
        this.iconList = res.data || []
      })
      this.$http.get('/index/navlist').then(res => {
        const result = res.data || []
        this.navList = result.map(item => {
          return {
            name: item.title,
            path: item.menu_url
          }
        })
      })
      this.$http.get('/index/partnerList').then(res => {
        this.swiperList = res.data || []
      })
      this.loadContactInfo()
    },
    // 联系信息（含门店列表 store_list，接口未返回时门店列自动隐藏）
    // country 优先级：URL 参数 > localStorage（过滤 'undefined' 残留，避免脏参数请求）
    loadContactInfo() {
      const urlCountry = this.$route && this.$route.query && this.$route.query.country
      const storedCountry = localStorage.getItem('country')
      const country = urlCountry || (storedCountry && storedCountry !== 'undefined' ? storedCountry : '')
      this.$http.get('/index/contact_information', { country: country }).then(res => {
        const data = res.data || {}
        this.contactInfo = data
        this.icpNumber = data.icp || ''
        this.storeList = this.normalizeStoreList(data.store_list)
      }).catch(() => {})
    },
    // 门店列表规范化：兼容扁平数组 [{...}] 与嵌套数组 [[{...}],[{...}]]
    normalizeStoreList(rawList) {
      if (!Array.isArray(rawList) || !rawList.length) return []
      const flat = []
      rawList.forEach(item => {
        if (Array.isArray(item)) {
          item.forEach(store => {
            if (store && typeof store === 'object') flat.push(store)
          })
        } else if (item && typeof item === 'object') {
          flat.push(item)
        }
      })
      return flat.map(store => this.decorateStore(store))
    },
    // 获取门店地图链接：优先接口 map_url，为空时自动拼接 Google Maps 搜索链接
    getMapUrl(store) {
      if (store.map_url) return store.map_url
      if (store.address) {
        return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(store.address)}`
      }
      return 'https://www.google.com/maps'
    },
    // 为门店补充国旗 emoji（后端未返回 flag 时按国家码映射）
    decorateStore(store) {
      const flagMap = {
        KH: '🇰🇭', RW: '🇷🇼', DZ: '🇩🇿', CN: '🇨🇳',
        KH_CAMBODIA: '🇰🇭', RW_RWANDA: '🇷🇼', DZ_ALGERIA: '🇩🇿'
      }
      const code = store.country_code || store.country || ''
      return {
        ...store,
        flag: store.flag || flagMap[code] || ''
      }
    },
    // 打开二维码放大预览
    openQrPreview(url, title) {
      if (!url) return
      this.previewQrUrl = url
      this.previewQrTitle = title || ''
      this.showQrPreview = true
    },
    // 打开咨询弹窗（可携带具体门店）
    openInquiry(store) {
      this.inquiryStore = store || null
      this.showInquiry = true
      // 推送咨询弹窗打开事件
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'inquiry_open',
          event_category: 'Footer',
          event_action: 'open_inquiry',
          event_label: store ? store.name : 'general'
        })
      }
    },
    handleSubmit() {
      if (!this.formData.email && !this.formData.whatsapp) {
        this.$toast({
          message: this.$t('bottom_contact_page.email_required', 'Please fill in your Email or WhatsApp'),
          duration: 3000
        })
        return
      }
      this.contactLoading = true
      const payload = { ...this.formData }
      if (this.inquiryStore) {
        payload.store = this.inquiryStore.name
      }
      this.$http.post('/contact/send', payload).then(res => {
        this.$toast({
          message: res.message,
          duration: 3000
        })
        // 推送表单提交事件到 Google Analytics / Google Tag Manager
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'form_submission', // 自定义事件名
            event_category: 'Form Submission', // 事件类别
            event_action: 'submit', // 事件操作
            event_label: payload.email || 'Anonymous', // 事件标签（这里用邮箱或匿名）
            form_data: payload // 可选：提交的表单数据
          })
        }
        this.formData.message = ''
        this.formData.whatsapp = ''
        this.formData.email = ''
        this.showInquiry = false
        this.inquiryStore = null
      }).finally(() => {
        this.contactLoading = false
      })
    },
    handleMouseEnter() {
      this.isHovering = true
    },
    handleMouseLeave() {
      this.isHovering = false
    },
    handleSwiperItemClick(item) {
      if (item.jump_type === 'link' || item.jump_type === 'video') {
        window.open(item.jump_url, '_blank')
      }
    },
    handleIconClick(icon) {
      const contactValue = icon.contact_value
      switch (icon.type_code) {
        case 'top':
          // 回到顶部功能 - 改进版本，兼容iOS Safari
          try {
            // 方法1: 尝试滚动整个页面
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            })

            // 方法2: 如果有布局内容容器，也滚动它
            const layoutContent = document.querySelector('.layout-content')
            if (layoutContent) {
              layoutContent.scrollTo({
                top: 0,
                behavior: 'smooth'
              })
            }

            // 方法3: 滚动文档根元素
            document.documentElement.scrollTo({
              top: 0,
              behavior: 'smooth'
            })

            // 方法4: 滚动body元素
            document.body.scrollTo({
              top: 0,
              behavior: 'smooth'
            })
          } catch (error) {
            // 降级处理：使用立即滚动而非平滑滚动
            try {
              window.scrollTo(0, 0)
              document.documentElement.scrollTo(0, 0)
              document.body.scrollTo(0, 0)

              const layoutContent = document.querySelector('.layout-content')
              if (layoutContent) {
                layoutContent.scrollTo(0, 0)
              }
            } catch (fallbackError) {
              console.warn('回到顶部功能降级处理失败:', fallbackError)
            }
          }
          break
        case 'phone':
          // 打开手机拨号功能（PC端会显示提示）
          window.location.href = `tel:${contactValue}`
          break
        case 'email':
          if (window.dataLayer) {
            window.dataLayer.push({
              event: 'email_click',
              event_category: 'email_click',
              event_action: 'click',
              element_class: 'footer-icon-list-email',
              event_label: contactValue
            })
          }
          // 打开邮件客户端
          window.location.href = `mailto:${contactValue}`
          break
        case 'url':
          // 打开网页链接
          // 确保链接包含协议
          let url = contactValue
          if (!url.startsWith('http://') && !url.startsWith('https://')) {
            url = `https://${url}`
          }
          window.open(url, '_blank')
          break
        case 'wechat':
          // 微信：如果是链接则打开，如果是微信号则显示提示
          if (contactValue.startsWith('http://') || contactValue.startsWith('https://')) {
            window.open(contactValue, '_blank')
          }
          break
        case 'whatsapp':
          if (window.dataLayer) {
            window.dataLayer.push({
              event: 'whatsapp_click',
              event_category: 'whatsapp_click',
              event_action: 'click',
              element_class: 'footer-icon-list-whatsapp',
              event_label: contactValue
            })
          }
          window.open(contactValue, '_blank')
          break
        default:
          // 其他类型，如果有链接则打开
          if (contactValue.startsWith('http://') || contactValue.startsWith('https://')) {
            window.open(contactValue, '_blank')
          }
      }
    },
    handleIconMouseEnter(event) {
      const icon = event.currentTarget
      const iconElement = this.iconList.find(item => item.id === parseInt(icon.dataset.iconId))
      if (!iconElement) return

      // 显示 tooltip
      this.showTooltip = iconElement.id

      // 动态检测 tooltip 是否会超出屏幕右边界
      this.$nextTick(() => {
        const tooltip = icon.querySelector('.footer-tooltip')
        if (!tooltip) return

        const tooltipWidth = tooltip.offsetWidth

        // 获取图标的位置
        const iconRect = icon.getBoundingClientRect()
        const iconCenterX = iconRect.left + iconRect.width / 2
        const tooltipLeft = iconCenterX - tooltipWidth / 2
        const tooltipRight = tooltipLeft + tooltipWidth

        // 如果 tooltip 会超出屏幕右边界，添加 right-align class
        if (tooltipRight > window.innerWidth - 20) {
          icon.classList.add('tooltip-right-align')
        } else {
          icon.classList.remove('tooltip-right-align')
        }
      })
    },
    handleIconMouseLeave(event) {
      // 隐藏 tooltip
      this.showTooltip = null
      const icon = event.currentTarget
      icon.classList.remove('tooltip-right-align')
    }
  }
}
</script>

<style scoped lang="less">
.pc-footer {
  position: relative !important;
  background-color: #256865;
  color: #fff;
  width: 100% !important;
  z-index: 1;
  margin-top: 0 !important;

  .footer-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 40px 40px 32px;
  }

  /* ---------- Partner 跑马灯（压缩高度） ---------- */
  .footer-partner {
    border-bottom: 1px solid rgba(50, 159, 155, 0.5);
    padding-bottom: 22px;
    margin-bottom: 30px;

    h4 {
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 1px;
      margin-bottom: 14px;
      color: #fff;
      display: flex;
      align-items: center;
      gap: 10px;

      &::after {
        content: '';
        flex: 1;
        height: 1px;
        background: rgba(50, 159, 155, 0.4);
      }
    }

    .swiper-container {
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 10px;
      overflow: hidden;
      width: 100%;

      // 左右渐隐蒙层
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 160px;
        height: 100%;
        background: linear-gradient(to right, rgba(30, 104, 101, 0.95), transparent);
        z-index: 10;
        pointer-events: none;
      }

      &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        width: 160px;
        height: 100%;
        background: linear-gradient(to left, rgba(30, 104, 101, 0.95), transparent);
        z-index: 10;
        pointer-events: none;
      }
    }

    .seamless-warp {
      overflow: hidden;
      width: 100%;
    }

    .swiper-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;

      .swiper-item {
        width: 62px;
        height: 38px;
        flex-shrink: 0;
        border-radius: 6px;
        padding: 5px;
        background: rgba(50, 159, 155, 0.35);
        margin-right: 12px;
        cursor: pointer;
        border: 1px solid rgba(255, 255, 255, 0.3);

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          border-radius: 3px;
        }
      }
    }
  }

  /* ---------- 三列主区 ---------- */
  .footer-columns {
    display: flex;
    gap: 60px;
    justify-content: space-between;
    align-items: flex-start;
  }

  .footer-col {
    flex-shrink: 0;
  }

  .col-stores { width: 560px; }
  .col-nav { width: 220px; }
  .col-contact { width: 320px; }

  .col-title {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 18px;
    padding-bottom: 8px;
    position: relative;
    color: #fff;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 30px;
      height: 2px;
      background: #ba3d38;
      border-radius: 2px;
    }
  }

  /* 门店列（紧凑卡片） */
  .store-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .store-card {
    display: flex;
    align-items: center;
    gap: 14px;
    background: rgba(50, 159, 155, 0.18);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 10px;
    padding: 12px 16px;
    transition: border-color 0.25s ease;

    &:hover {
      border-color: rgba(255, 255, 255, 0.35);
    }

    .store-head {
      display: flex;
      align-items: center;
      gap: 6px;
      flex-shrink: 0;
      width: 160px;

      .store-flag {
        font-size: 15px;
        line-height: 1;
        display: inline-flex;
        align-items: center;
        flex-shrink: 0;
      }

      .store-name {
        font-size: 13px;
        font-weight: 600;
        color: #fff;
        letter-spacing: 0.2px;
        line-height: 1.35;
        word-break: break-word;
        overflow-wrap: anywhere;
      }
    }

    .store-info {
      flex: 1;
      min-width: 0;

      .store-address {
        display: flex;
        align-items: flex-start;
        gap: 6px;
        font-style: normal;
        font-size: 12.5px;
        line-height: 1.4;
        color: rgba(255, 255, 255, 0.72);
        text-decoration: none;
        transition: color 0.2s ease;

        &:hover {
          color: #fff;

          .address-map-link {
            color: #fff;
            text-decoration: underline;
          }
        }

        svg {
          width: 13px;
          height: 13px;
          fill: #7fd4d0;
          flex-shrink: 0;
          margin-top: 2px;
        }

        .address-text {
          min-width: 0;
        }

        .address-local {
          display: block;
          margin-top: 3px;
          padding-left: 19px;
          font-size: 11.5px;
          line-height: 1.5;
          color: rgba(255, 255, 255, 0.5);
          unicode-bidi: plaintext;
        }

        .address-map-link {
          display: block;
          margin-top: 3px;
          font-size: 11.5px;
          color: #7fd4d0;
          transition: color 0.2s ease;
        }
      }

      .store-contacts-row {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 6px 14px;
        margin-top: 6px;

        .store-tel {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          font-size: 12.5px;
          color: rgba(255, 255, 255, 0.9);
          text-decoration: none;
          white-space: nowrap;
          transition: color 0.2s ease;

          &:hover {
            color: #fff;
            text-decoration: underline;
          }

          svg {
            width: 13px;
            height: 13px;
            fill: #7fd4d0;
            flex-shrink: 0;
          }
        }

        .store-link-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 26px;
          height: 26px;
          border-radius: 50%;
          background: rgba(50, 159, 155, 0.35);
          border: 1px solid rgba(255, 255, 255, 0.25);
          transition: all 0.25s ease;

          &:hover {
            background: #ba3d38;
            border-color: #ba3d38;
            transform: translateY(-1px);
          }

          svg {
            width: 13px;
            height: 13px;
            fill: #fff;
          }
        }
      }
    }

    .store-actions {
      display: flex;
      align-items: center;
      gap: 10px;
      flex-shrink: 0;

      .store-inquiry-btn {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        padding: 7px 14px;
        background: rgba(255, 255, 255, 0.12);
        border: 1px solid rgba(255, 255, 255, 0.3);
        border-radius: 999px;
        color: #fff;
        font-size: 12.5px;
        cursor: pointer;
        white-space: nowrap;
        transition: all 0.25s ease;

        &:hover {
          background: #ba3d38;
          border-color: #ba3d38;
        }

        svg {
          width: 13px;
          height: 13px;
          fill: currentColor;
        }
      }
    }
  }

  /* 导航列 */
  .nav-list {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .nav-link {
      color: rgba(255, 255, 255, 0.8);
      text-decoration: none;
      font-size: 13.5px;
      transition: all 0.2s ease;
      position: relative;
      padding-left: 14px;

      &::before {
        content: '›';
        position: absolute;
        left: 0;
        color: #329f9b;
        transition: all 0.2s ease;
      }

      &:hover {
        color: #fff;
        padding-left: 18px;

        &::before {
          color: #ba3d38;
        }
      }
    }
  }

  .legal-links {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 18px;
    padding-top: 14px;
    border-top: 1px solid rgba(50, 159, 155, 0.4);

    .legal-link {
      color: rgba(255, 255, 255, 0.55);
      text-decoration: none;
      font-size: 12.5px;
      transition: color 0.2s ease;

      &:hover {
        color: #fff;
      }
    }
  }

  /* 联系我们列 */
  .contact-list {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .contact-item {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      color: rgba(255, 255, 255, 0.85);
      text-decoration: none;
      font-size: 13px;
      line-height: 1.5;
      transition: color 0.2s ease;

      &:hover {
        color: #fff;
      }

      .ci-icon {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: rgba(50, 159, 155, 0.4);
        border: 1px solid rgba(255, 255, 255, 0.25);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        svg {
          width: 14px;
          height: 14px;
          fill: #fff;
        }
      }

      .ci-label {
        display: block;
        font-size: 11px;
        color: rgba(255, 255, 255, 0.55);
        margin-bottom: 2px;
      }
    }
  }

  .contact-inquiry-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-top: 14px;
    padding: 9px 18px;
    background: #fff;
    border: none;
    border-radius: 999px;
    color: #ba3d38;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.25s ease;

    &:hover {
      background: #ba3d38;
      color: #fff;
    }

    svg {
      width: 14px;
      height: 14px;
      fill: currentColor;
    }
  }

  .qr-row {
    margin-top: 14px;
    display: flex;
    justify-content: center;
    gap: 10px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 10px;
    padding: 12px;

    .qr-item {
      flex: 1;
      min-width: 0;
      text-align: center;

      img.qr-thumb {
        width: 76px;
        height: 76px;
        margin: 0 auto 6px;
        display: block;
        background: #fff;
        border-radius: 6px;
        object-fit: contain;
        cursor: pointer;
        transition: transform 0.2s ease, box-shadow 0.2s ease;

        &:hover {
          transform: scale(1.06);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
        }
      }

      p {
        font-size: 11px;
        color: rgba(255, 255, 255, 0.7);
        line-height: 1.3;
        word-break: break-word;
      }
    }
  }

  /* ---------- 底部版权条 ---------- */
  .footer-bottom {
    border-top: 1px solid rgba(50, 159, 155, 0.5);
    padding: 16px 40px;

    .footer-bottom-inner {
      max-width: 1600px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .copyright {
        font-size: 12.5px;
        color: rgba(255, 255, 255, 0.6);

        .icp {
          margin-left: 14px;
          font-size: 11.5px;
          color: rgba(255, 255, 255, 0.4);
        }

        .outlink {
          margin-left: 14px;
          font-size: 11.5px;

          a {
            color: rgba(255, 255, 255, 0.7);
            text-decoration: none;

            &:hover {
              color: #329f9b;
              text-decoration: underline;
            }
          }
        }
      }

      .footer-icon-list {
        display: flex;
        align-items: center;
        gap: 12px;

        .footer-icon {
          position: relative;
          cursor: pointer;
          transition: transform 0.3s, opacity 0.3s;

          &:hover {
            transform: scale(1.1);
            opacity: 0.8;
          }

          // 动态右对齐的 tooltip
          &.tooltip-right-align {
            .footer-tooltip {
              left: auto;
              right: 0;
              transform: translateX(0) translateY(-5px);
            }

            .footer-tooltip::after {
              left: auto;
              right: 20px;
              transform: translateX(0);
            }

            &:hover .footer-tooltip {
              transform: translateX(0) translateY(-10px);
            }
          }

          &:active {
            transform: scale(0.95);
          }

          // Tooltip 浮层
          .footer-tooltip {
            position: absolute;
            bottom: 100%;
            left: 50%;
            transform: translateX(-50%) translateY(-5px);
            background-color: rgba(0, 0, 0, 0.8);
            color: #fff;
            border-radius: 6px;
            font-size: 14px;
            pointer-events: none;
            opacity: 0;
            visibility: hidden;
            transition: opacity 0.3s, transform 0.3s, visibility 0.3s;
            z-index: 1000;
            margin-bottom: 8px;
            display: flex;
            align-items: center;
            justify-content: center;

            // Tooltip 箭头
            &::after {
              content: '';
              position: absolute;
              bottom: -12px;
              left: 50%;
              transform: translateX(-50%);
              border: 6px solid transparent;
              border-top-color: rgba(0, 0, 0, 0.8);
            }

            .tooltip-image {
              min-width: 150px;
              min-height: 150px;
              display: block;
              border-radius: 4px;
            }

            span {
              white-space: nowrap;
              padding: 8px 12px;
            }
          }

          &:hover .footer-tooltip {
            opacity: 1;
            visibility: visible;
            transform: translateX(-50%) translateY(-10px);
          }

          img {
            width: 30px;
            height: 30px;
            border-radius: 50%;
          }
        }
      }
    }
  }

  /* ---------- 咨询弹窗 ---------- */
  .inquiry-popup {
    width: 420px;
    max-width: 90vw;
    border-radius: 12px;
    overflow: hidden;
  }

  .qr-preview-popup {
    width: 320px;
    max-width: 88vw;
    border-radius: 12px;
    overflow: hidden;

    .qr-preview-box {
      position: relative;
      padding: 28px 20px 20px;
      text-align: center;

      img {
        width: 220px;
        height: 220px;
        display: block;
        margin: 0 auto 10px;
        background: #fff;
        border-radius: 8px;
        object-fit: contain;
      }

      p {
        font-size: 13px;
        color: #666;
        line-height: 1.4;
      }

      .qr-preview-close {
        position: absolute;
        top: 10px;
        right: 10px;
      }
    }
  }

  .inquiry-box {
    padding: 24px;

    .inquiry-header {
      position: relative;
      margin-bottom: 16px;
      text-align: center;

      h4 {
        font-size: 18px;
        font-weight: 700;
        color: #256865;
        margin-bottom: 4px;
      }

      p {
        font-size: 13px;
        color: #969799;
      }

      .inquiry-close {
        position: absolute;
        top: -6px;
        right: -6px;
        width: 30px;
        height: 30px;
        border: none;
        background: #f5f6f7;
        border-radius: 50%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;

        &:hover {
          background: #ee0a24;
        }

        svg {
          width: 16px;
          height: 16px;
          fill: #646566;
        }

        &:hover svg {
          fill: #fff;
        }
      }
    }

    .form-textarea {
      width: 100%;
      height: 90px;
      padding: 12px;
      background: #f5f6f7;
      border: 1px solid #ebedf0;
      border-radius: 8px;
      color: #323233;
      font-size: 14px;
      resize: none;
      margin-bottom: 12px;
      outline: none;
      font-family: inherit;
      box-sizing: border-box;

      &::placeholder {
        color: #c8c9cc;
      }

      &:focus {
        border-color: #256865;
      }
    }

    .form-input {
      width: 100%;
      height: 44px;
      padding: 0 12px;
      background: #f5f6f7;
      border: 1px solid #ebedf0;
      border-radius: 8px;
      color: #323233;
      font-size: 14px;
      margin-bottom: 12px;
      outline: none;
      font-family: inherit;
      box-sizing: border-box;

      &::placeholder {
        color: #c8c9cc;
      }

      &:focus {
        border-color: #256865;
      }
    }

    .form-submit {
      width: 100%;
      height: 46px;
      background: #256865;
      border: none;
      border-radius: 8px;
      color: #fff;
      font-size: 15px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.25s ease;
      letter-spacing: 0.5px;

      &:hover {
        background: #ba3d38;
      }

      &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
      }
    }
  }
}
</style>
